import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  DeactivateVirtualCardContentMatchParams,
  deactivateVirtualCardContentRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectVirtualCardListModels,
  selectVirtualCardSecureModels,
} from 'src/redux/selectors/data/virtualCards.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<DeactivateVirtualCardContentMatchParams>(
      location.pathname,
      deactivateVirtualCardContentRouteProps,
    ) as match<DeactivateVirtualCardContentMatchParams>
    return mtch.params.id
  },
)

export const selectVirtualCard = createSelector(
  [selectVirtualCardSecureModels, selectVirtualCardIdFromRoute],
  (virtualCards, virtualCardId) => {
    return virtualCards[virtualCardId] !== undefined
      ? virtualCards[virtualCardId]
      : undefined
  },
)

export const selectVirtualCardListModel = createSelector(
  [selectVirtualCardListModels, selectVirtualCardIdFromRoute],
  (virtualCards, virtualCardId) => {
    return virtualCards[virtualCardId] !== undefined
      ? virtualCards[virtualCardId]
      : undefined
  },
)

export const selectPuttingVirtualCardCancelFromState = (
  state: RootState,
): boolean => state.app.deactivateVirtualCardContent.puttingVirtualCardCancel

export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.deactivateVirtualCardContent.topLevelError

export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.deactivateVirtualCardContent.errorDetailMap
